'use client';

import { Flex } from '@chakra-ui/react';
import { useLocale } from 'next-intl';

import { useJobSearchQuery } from '@/modules/job/application';
import { JobList } from '@/modules/job/presentation/components/JobList/JobList';
import { JobSearchFilter } from '@/modules/job/presentation/composites';
import {
	jobSearchDtoToVM, useRemoveJobHandler, useSaveJobHandler,
} from '@/modules/job/view-models';

export const JobSearchResultContainer = () => {
	const locale = useLocale();
	const saveJobHandler = useSaveJobHandler();
	const removeJobHandler = useRemoveJobHandler();

	const { data, isLoading } = useJobSearchQuery(
		{},
		data => ({
			jobs:       data.body.result.jobs.map(job => jobSearchDtoToVM(job, locale)),
			pagination: data.body.result.pagination,
		}),
	);

	const jobs = data?.jobs ?? [];

	return (
		<Flex gap={8} w="100%">
			<JobSearchFilter />
			<JobList
				handleAddInterestedJob={saveJobHandler.execute}
				handleRemoveInterestedJob={removeJobHandler.execute}
				isLoading={isLoading}
				jobList={jobs}
			/>
		</Flex>
	);
};
